import { IOption } from '@gcl/react-core';

export const designBriefActionerOptions: IOption<string>[] = [
  { key: 'SRP', text: 'SRP' },
  { key: 'TWC', text: 'TWC' },
  { key: '-', text: 'No Action' },
  { key: 'Cancelled', text: 'Cancelled' },
];
